import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './AboutSection.css';

const AboutSection = ({ icon, backgroundImage, title, text }) => {
  return (
    <div className="about-section" style={{ backgroundImage: `url(${backgroundImage})` }}>
      <div className="about-content">
        <FontAwesomeIcon icon={icon} className="about-icon"/>
        <h1 className="about-title">{title}</h1>
        <p className="about-text">{text}</p>
      </div>
    </div>
  );
};

export default AboutSection;
